import { Link } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import './Cart.css';

function formatPrice(value) {
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
  }).format(value);
}

function Cart() {
  const { items, removeItem, updateQuantity, clearCart, totalItems, totalPrice } = useCart();

  const handleOrder = () => {
    if (items.length === 0) return;

    let message = '¡Hola! Me gustaría hacer un pedido:\n\n';

    items.forEach((item, i) => {
      message += `${i + 1}. *${item.nombre}*`;
      if (item.marca) message += ` (${item.marca})`;
      message += '\n';
      if (item.precioDescripcion) message += `   Presentación: ${item.precioDescripcion}\n`;
      if (item.colorNombre) message += `   Color: ${item.colorNombre}\n`;
      message += `   Cantidad: ${item.cantidad}\n`;
      message += `   Precio: ${formatPrice(item.precioValor * item.cantidad)}\n`;
      message += '\n';
    });

    message += `*Total: ${formatPrice(totalPrice)}*\n`;
    message += '\n¡Gracias!';

    const encoded = encodeURIComponent(message);
    window.open(`https://wa.me/+573216595562?text=${encoded}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="cart-page">
      {items.length === 0 ? (
        <div className="cart-empty">
          <p>Tu carrito está vacío</p>
          <Link to="/productos" className="cart-empty-link">
            Ver productos
          </Link>
        </div>
      ) : (
        <div className="cart-layout">
          <div className="cart-items">
            {items.map((item) => (
              <div
                key={`${item.productId}_${item.precioId}_${item.colorId}`}
                className="cart-item"
              >
                <div className="cart-item-img">
                  {item.imagen ? (
                    <img src={item.imagen} alt={item.nombre} />
                  ) : (
                    <div className="cart-item-placeholder" />
                  )}
                </div>

                <div className="cart-item-info">
                  <span className="cart-item-brand">{item.marca}</span>
                  <h3 className="cart-item-name">{item.nombre}</h3>
                  {item.precioDescripcion && (
                    <span className="cart-item-detail">{item.precioDescripcion}</span>
                  )}
                  {item.colorNombre && (
                    <span className="cart-item-detail">
                      <span
                        className="cart-item-color-dot"
                        style={{ backgroundColor: item.colorHex }}
                      />
                      {item.colorNombre}
                    </span>
                  )}
                </div>

                <div className="cart-item-qty">
                  <button
                    onClick={() =>
                      updateQuantity(item.productId, item.precioId, item.colorId, item.cantidad - 1)
                    }
                    disabled={item.cantidad <= 1}
                  >
                    −
                  </button>
                  <span>{item.cantidad}</span>
                  <button
                    onClick={() =>
                      updateQuantity(item.productId, item.precioId, item.colorId, item.cantidad + 1)
                    }
                  >
                    +
                  </button>
                </div>

                <span className="cart-item-price">
                  {formatPrice(item.precioValor * item.cantidad)}
                </span>

                <button
                  className="cart-item-remove"
                  onClick={() => removeItem(item.productId, item.precioId, item.colorId)}
                  title="Eliminar"
                >
                  ✕
                </button>
              </div>
            ))}
          </div>

          <div className="cart-summary">
            <h2 className="cart-summary-title">Resumen del pedido</h2>
            <div className="cart-summary-row">
              <span>Productos ({totalItems})</span>
              <span>{formatPrice(totalPrice)}</span>
            </div>
            <div className="cart-summary-divider" />
            <div className="cart-summary-row cart-summary-total">
              <span>Total</span>
              <span>{formatPrice(totalPrice)}</span>
            </div>
            <button className="cart-order-btn" onClick={handleOrder}>
              Hacer pedido
            </button>
            <button className="cart-clear-btn" onClick={clearCart}>
              Vaciar carrito
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Cart;
